
    .responsive3839243538__root.responsive3839243538--darkMode {
    }

/* st-namespace-reference="../../../../src/skins/responsive/darkMode.st.css" */